import { type Loadable } from '@/loadingUtils'
import type { StudentAggStats, GroupAggStats, StudentStats } from '@/store/stats/types'

export type TDateRange = 'last7' | 'last30' | 'last90'

export type TStatsModuleState = {
    studentStats: { [ orgStudentId: string ]: Loadable<StudentStats> }
    studentAggStats: { [ orgStudentId: string ]: Loadable<StudentAggStats> }
    groupAggStats: { [ orgGroupId: string]: Loadable<GroupAggStats> }
}

export const getInitialStatsState = (): TStatsModuleState => {
    return {
        studentStats: {},
        studentAggStats: {},
        groupAggStats: {},
    }
}

const moduleState = getInitialStatsState()

export default moduleState
